import { render, staticRenderFns } from "./news-section.vue?vue&type=template&id=386c85d6&"
import script from "./news-section.vue?vue&type=script&lang=js&"
export * from "./news-section.vue?vue&type=script&lang=js&"
import style0 from "./news-section.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports